import { type Resolver, useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { SummaryPagePayload } from "../types";

export const useSummaryForm = () => {
	const schema = z.object({
		marketingConsent: z.boolean().optional(),
	});

	return {
		useForm: useForm<SummaryPagePayload, unknown, SummaryPagePayload>({
			resolver: zodResolver(schema) as unknown as Resolver<
				SummaryPagePayload,
				unknown,
				SummaryPagePayload
			>,
			mode: "onTouched",
			defaultValues: {
				marketingConsent: false,
			},
		}),
		schema,
	};
};
